export default __webpack_public_path__ + "static/modal01_02-sp-9923063e0092eb6d42fbd373b07fd4e2.svg";